import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToAddBuilding: {
        id: "twia.quoteandbind.cp.views.building.Unable to add Building",
        defaultMessage: "Unable to add Building"
    },
    updateBuildingCoveragesCallFailed: {
        id: "twia.quoteandbind.cp.views.building.Please check for errors and try again",
        defaultMessage: "Please check for errors and try again"
    },
    removeBalnket: {
        id: "twia.quoteandbind.cp.views.building.Blanket not removed",
        defaultMessage: "Blanket not removed"
    },
    addBlanket: {
        id: "twia.quoteandbind.cp.views.building.Blanket not added",
        defaultMessage: "Blanket not added"
    }
    
})